import { backendFetch } from './apiUtils';

export const getExciseOptions = async () => {
  return await backendFetch({
    url: 'excise/options',
    method: 'GET',
  });
};
